import { useMutation, useQueryClient } from "react-query";
import { useDirections } from "./useDirections";
import { AxiosError } from 'axios';

interface MutateOptions {
  onSuccess?: () => void;
  onError?: (error: AxiosError) => void;
}

interface DataIProps {
  instanceId: number;
}

export const useDeleteDirection = (queryKey: string | any[] = "directions") => {
  const { deleteDitection } = useDirections();
  const queryClient = useQueryClient();

  const mutation = useMutation<void, AxiosError, DataIProps>({
    mutationKey: ["deleteDirection", queryKey],
    mutationFn: async (props: DataIProps) => {
      try {
        await deleteDitection(props.instanceId);
      } catch (error: any) {
        console.error("Error deleting direction:", error);
        throw error;
      }
    },
    onError: (err: AxiosError, variables: DataIProps, context?: any) => {
      console.error("Mutation failed:", err.message);
    },
    onSuccess: (data, variables) => {
      console.log("Direction deleted successfully!");
    },
    onSettled: () => {
      queryClient.invalidateQueries(queryKey);
    },
  });

  const deleteFn = (instanceId: number, options?: MutateOptions) => {
    mutation.mutate({ instanceId }, {
      onSuccess: () => {
        options?.onSuccess?.();
      },
      onError: (error: AxiosError) => {
        options?.onError?.(error);
      }
    });
  };

  return {
    deleteFn,
    isLoading: mutation.isLoading,
    isError: mutation.isError,
    error: mutation.error,
    isSuccess: mutation.isSuccess,
  };
};
